import { render, staticRenderFns } from "./videoDataPage.vue?vue&type=template&id=6e5f69a9&scoped=true"
import script from "./videoDataPage.vue?vue&type=script&lang=js"
export * from "./videoDataPage.vue?vue&type=script&lang=js"
import style0 from "./videoDataPage.vue?vue&type=style&index=0&id=6e5f69a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f69a9",
  null
  
)

export default component.exports